import { render, staticRenderFns } from "./QIShelves.vue?vue&type=template&id=9494989a&scoped=true&"
import script from "./QIShelves.vue?vue&type=script&lang=js&"
export * from "./QIShelves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9494989a",
  null
  
)

export default component.exports